import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ddbb174a")

_pushScopeId("data-v-ddbb174a")
const _hoisted_1 = {
  key: 0,
  class: "ui__configurationInfo_main",
  id: "ConfigInfo"
}
const _hoisted_2 = { class: "ui__configurationInfo_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ui__line_main" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_componentTitle = _resolveComponent("componentTitle")
  const _component_infoList = _resolveComponent("infoList")

  return (_ctx.state.reportLevel !== 4)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_componentTitle, {
            title: "配置信息",
            listSumNumber: _ctx.state.listSumNumber
          }, null, 8, ["listSumNumber"]),
          _createVNode(_component_infoList, {
            dataList: _ctx.state.dataList,
            labelWidth: "60%",
            valueWidth: "40%"
          }, null, 8, ["dataList"])
        ]),
        _hoisted_3
      ]))
    : _createCommentVNode("", true)
})